import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { Box, Container, Button } from '@mui/material';
import { useHistory } from 'react-router-dom';
import noAccessBg from '../../assets/images/no_access/background.png';
import noAccessImg from '../../assets/images/no_access/image.png';
import { setDashboardStatus } from '@/redux/slices/dashboardSlice';
import { LoadingStatuses } from '@/constants/constants';
import { useAppDispatch } from '@/redux/hooks';

const NoRoute = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setDashboardStatus(LoadingStatuses.fulfilled));
  }, []);

  const goBack = () => {
    history.goBack();
  };

  return (
    <StyledContainer sx={{ pt: 3 }}>
      <StyledBackgroundBox>
        <Box sx={{ ml: 10, mt: -5 }}>
          <StyledTitle>Oops!</StyledTitle>
          <StyledText>Looks like you don’t have access to this page. </StyledText>
          <StyledText>Reach out to Platform Support for assistance.</StyledText>
          <StyledButton variant="contained" sx={{ mt: 2 }} onClick={goBack}>
            Go Back
          </StyledButton>
        </Box>
        <StyledNoAccessImg src={noAccessImg} alt="page not found" />
      </StyledBackgroundBox>
    </StyledContainer>
  );
};

export default NoRoute;

const StyledContainer = styled(Container)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  min-height: calc(100vh - 357px);
`;

const StyledBackgroundBox = styled(Box)`
  background-image: url(${noAccessBg});
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  width: auto;
  height: 35rem;
  background-size: 66rem 35rem;
`;

const StyledTitle = styled.h1`
  font-size: 7rem;
  line-height: 8rem;
  margin: 0;
`;

const StyledText = styled.p`
  font-size: 1.1rem;
  margin: 0;

  &:nth-of-type(1) {
    margin-top: ${({ theme }) => theme.spacing(2)};
  }
`;

const StyledButton = styled(Button)`
  text-transform: none;
  font-size: 1.1rem;
`;

const StyledNoAccessImg = styled.img(
  ({ theme }) => `
  margin-top: ${theme.spacing(5)};
  margin-left: ${theme.spacing(-5)};
  width: 45rem;
  height: auto;
`
);
